import { render, staticRenderFns } from "./ChromaVideoUpload.vue?vue&type=template&id=70b46e89&"
import script from "./ChromaVideoUpload.vue?vue&type=script&lang=js&"
export * from "./ChromaVideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./ChromaVideoUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports